import { State } from "@/store/modules/teams/index";

const setIsTeams = (state: State, payload: boolean): void => {
  state.isTeams = payload;
};

export default {
  setIsTeams
};